import { render, staticRenderFns } from "./TaskBlockDetail.vue?vue&type=template&id=1f645f27&scoped=true&"
import script from "./TaskBlockDetail.vue?vue&type=script&lang=js&"
export * from "./TaskBlockDetail.vue?vue&type=script&lang=js&"
import style0 from "./TaskBlockDetail.vue?vue&type=style&index=0&id=1f645f27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f645f27",
  null
  
)

export default component.exports